<ng-container *limitUp="DEVICE_SIZE.DESKTOP">
  <nav class="container-desktop-category-menu">
    @if (data.items.length > 0) {
      <ul class="first-level">
        <li *ngFor="let category of data.items">
          <cx-link [link]="category">
            <div class="d-flex gap-1 align-items-center">
              <div class="title">
                {{ category.linkName }}
              </div>

              @if (category.children?.length) {
                <span class="icon material-symbols-outlined">keyboard_arrow_down</span>
              }
            </div>
          </cx-link>

          @if (category.children?.length) {
            <div class="second-level">
              <div class="container">
                <ul class="grid-links">
                  <li class="d-grid gap-2 mb-auto" *ngFor="let subCategory of category.children">
                    <cx-link [link]="subCategory">
                      <span class="title">
                        {{ subCategory.linkName }}
                      </span>
                    </cx-link>

                    @if (subCategory.children?.length) {
                      <ul class="third-level">
                        <li *ngFor="let link of subCategory.children">
                          <cx-link [link]="link">
                            {{ link.linkName }}
                          </cx-link>
                        </li>
                      </ul>
                    }
                  </li>
                </ul>

                @if (category.media) {
                  <cx-media class="box-image" [media]="category.media" />
                }
              </div>
            </div>
          }
        </li>
      </ul>
    }
  </nav>
</ng-container>

<ng-container *smallerThan="DEVICE_SIZE.DESKTOP">
  <abstract-lines [menu]="data.items" />
</ng-container>
